import axios from 'axios'
import { objectSnakeToCamelCase, objectCamelToSnakeCase, clone } from '@/util/libUtil'


const state = () => ({
	order: {
		isLoadingOrder: false,
		isLoadingOrderDetail: false,
		orderData: null,
		orderDataDetail: null,
		isUpdatedOrder: false,
	},
	stateUser: {
		active: {
			nombre: 'Activo',
			color: 'success',
			icon: 'check',
		},
		delivered: {
			nombre: 'Enviado',
			color: 'success',
			icon: 'cube-send',
			packageStatus: 'ACTIVO',
		},
		cancelled: {
			nombre: 'Cancelado',
			color: 'dark',
			icon: 'archive-cancel',
			packageStatus: 'CANCELADO',
		},
		fly: {
			nombre: 'En vuelo',
			color: 'warning',
			icon: 'airplane',
			packageStatus: 'VUELO',
		},
	},
	orderNumberToState: {
		6: 'delivered',
		7: 'cancelled',
		8: 'fly',
		79: 'fly',
		77: 'delivered',
		76: 'delivered',
	},
	statePackage: {
		ACTIVO: {
			nombre: 'Activo',
			color: 'success',
			icon: 'check',
		},
		CANCELADO: {
			nombre: 'Cancelado',
			color: 'dark',
			icon: 'archive-cancel',
		},
		VUELO: {
			nombre: 'En vuelo',
			color: 'warning',
			icon: 'airplane',
		},
	},
	contract: {
		isLoadingContract: false,
		contractData: null,
	},
	isOpenOrders: false,
	updateOrder: false,
	paths: {
		ordersPath: '/api/scraping/yoigo/cliente/ordenes/',
		ordersDetailPath: '/api/scraping/yoigo/cliente/ordenes/detail/',
		contractPath: '/api/scraping/yoigo/cliente/contrato/pdf/',
		paquetePath: '/api/atenciones/paquete/',
		additionalinfoPath: '/api/atenciones/additionalinfo/',
	}
})

const mutations = {
	updateOrder(state, val) {
		state.updateOrder = val
	},
	orderData(state, val) {
		state.order.orderData = val
	},
	orderDataDetail(state, val) {
		state.order.orderDataDetail = val
	},
	contractData(state, val) {
		state.contract.contractData = val
	},
	isLoadingOrder: (state, val) => {
		state.order.isLoadingOrder = val
	},
	isLoadingOrderDetail: (state, val) => {
		state.order.isLoadingOrderDetail = val
	},
	isLoadingContract: (state, val) => {
		state.contract.isLoadingContract = val
	},
	isOpenOrders: (state, val) => {
		state.isOpenOrders = val
	},
	isUpdatedOrder: (state, val) => {
		state.order.isUpdatedOrder = val
	}
}

const actions = {
	async getOrderDetail({ dispatch, getters, state, commit }, orderId) {
		try {
			commit('isLoadingOrder', true)
			const res = await axios.get(getters.getEndpointFromPath(state.paths.ordersPath), {
				params: {
					order_id: orderId
				}
			})
			commit('orderData', res.data)
			commit('isLoadingOrder', false)
		} catch (error) {
			commit('isLoadingOrder', false)
			console.log(error)
		}
	},
	async getOrderMoreDetail({ dispatch, getters, state, commit }, orderId) {
		try {
			commit('isLoadingOrderDetail', true)
			const res = await axios.get(getters.getEndpointFromPath(state.paths.ordersDetailPath), {
				params: {
					order_id: orderId
				}
			})
			commit('orderDataDetail', res.data)
			commit('isLoadingOrderDetail', false)
		} catch (error) {
			commit('isLoadingOrderDetail', false)
			console.log(error)
		}
	},
	async downloadPdfContract({ state, commit, getters, dispatch }, contractId) {
		try {
			commit('isLoadingContract', true)
			let resp = await axios.get(getters.getEndpointFromPath(state.paths.contractPath), {
				params: { contract_id: contractId },
				responseType: "blob"
			})
			commit('isLoadingContract', false)

			const blob = new Blob([resp.data], { type: 'application/pdf' })

			var fileURL = window.URL.createObjectURL(blob)
			var fileLink = document.createElement('a')

			fileLink.href = fileURL
			fileLink.setAttribute('download', resp.headers['content-disposition'] ? resp.headers['content-disposition'].split('filename=')[1] : `Contrato_${contractId}`)
			document.body.appendChild(fileLink)

			fileLink.click();
			document.body.removeChild(fileLink)
			window.URL.revokeObjectURL(fileURL)

		} catch (error) {
			dispatch('util/showStatusSnackBar', {
				statusType: 'error',
				message: 'Error al descargar el PDF del contrato'
			}, { root: true })
			commit('isLoadingContract', false)
			console.log(error)
		}
	},
	async updatePackages({ state, commit, getters, dispatch }, packageStatus) {
		try {
			const { id, estado, orderId } = packageStatus
			const res = await axios.put(`${getters.getEndpointFromPath(state.paths.paquetePath)}${id}/`, { estado, order_id: orderId })
			return res.data.estado
			// dispatch('util/showStatusSnackBar', {
			// 	statusType: 'success',
			// 	message: 'Estado de paquetes actualizado'
			// }, { root: true })
		} catch (error) {
			dispatch('util/showStatusSnackBar', {
				statusType: 'error',
				message: 'Error al actualizar el estado de los paquetes'
			}, { root: true })
			console.log(error)
		}
	},
	async createAdditionalInfo({ state, commit, getters, dispatch }, additionalinfo) {
		try {
			const res = await axios.post(
				getters.getEndpointFromPath(state.paths.additionalinfoPath),
				objectCamelToSnakeCase(additionalinfo)
			)
			return objectSnakeToCamelCase(res.data)
			// dispatch('util/showStatusSnackBar', {
			// 	statusType: 'success',
			// 	message: 'Estado de paquetes actualizado'
			// }, { root: true })
		} catch (error) {
			dispatch('util/showStatusSnackBar', {
				statusType: 'error',
				message: 'Error al actualizar el estado de los paquetes'
			}, { root: true })
			console.log(error)
		}
	},
	async updateAdditionalInfo({ state, commit, getters, dispatch }, additionalinfo) {
		try {
			const actualOrderId = additionalinfo.actualOrderId
			delete additionalinfo.actualOrderId
			const res = await axios.put(`${getters.getEndpointFromPath(state.paths.additionalinfoPath)}${actualOrderId}/`, objectCamelToSnakeCase(additionalinfo))
			return objectSnakeToCamelCase(res.data)
			// dispatch('util/showStatusSnackBar', {
			// 	statusType: 'success',
			// 	message: 'Estado de paquetes actualizado'
			// }, { root: true })
		} catch (error) {
			dispatch('util/showStatusSnackBar', {
				statusType: 'error',
				message: 'Error al actualizar el estado de los paquetes'
			}, { root: true })
			console.log(error)
		}
	}
}

const getters = {
	getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
		rootState.general.host + endpoint
	)
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}